class InfiniteScroll extends HTMLElement {

    constructor() {
      super();
      if (!this.dataset.paginationType) return;

      this.settings = {
        method: this.dataset.paginationType,
        container: '#product-grid',
        pagination: '.pagination',
        partial: '[data-partial]',
        triggerElement: "#InfiniteScrollTrigger",
        paginationItemsCount: '[data-pagination-item-count]',
        offset: 0,
        loadingText: this.dataset.clickLoadingText || 'Loading...',
      };

      // Functions
      this.addScrollListeners = this._addScrollListeners.bind(this);
      this.addClickListener = this._addClickListener.bind(this.containerElement);
      this.checkIfPaginationInView = this._checkIfPaginationInView.bind(this);
      this.preventMultipleClicks = this._preventMultipleClicks.bind(this);

      this.removeClickListener = this._removeClickListener.bind(this);
      this.removeScrollListener = this._removeScrollListener.bind(this);
      this.removePaginationElement = this._removePaginationElement.bind(this);
      this.destroy = this._destroy.bind(this);

      // Selectors
      this.containerElement = document.querySelector(`${this.settings.container}`);
      this.paginationElement = document.querySelector(`${this.settings.pagination}`);
      this.triggerElement = this
      this.paginationElementItemsCount = document.querySelector(`${this.settings.paginationItemsCount}`);
      this.partialElement = document.querySelector(`${this.settings.partial}`);
      this.initializeInfiniteScroll();
    }
    
    initializeInfiniteScroll() {
      if (!this.containerElement) {
        return;
      }

      const initializers = {
        click: this._addClickListener,
        scroll: this._addScrollListeners
      };
    
      initializers[this.settings.method]();
    }

    _addClickListener = () => {

      this.nextPageLinkElement = this.querySelector("a");
      this.clickActive = true;
    
      if (
        typeof this.nextPageLinkElement !== "undefined" &&
        this.nextPageLinkElement !== null
      ) {
        this.nextPageLinkElement.addEventListener(
          "click",
          this._preventMultipleClicks
        );
      }
    };

    _preventMultipleClicks = (
      event
    ) => {
      event.preventDefault();
    
      if (!this.clickActive) {
        return;
      }
      
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.clickActive = false;
    
      this._loadMore();
    };

    _removeClickListener = () => {
      this.nextPageLinkElement.removeEventListener(
        "click",
        this.preventMultipleClicks
      );
    };

    _addScrollListeners = () => {
      if (!this.triggerElement) {
        return;
      }

      document.addEventListener("scroll", this._checkIfPaginationInView);
      window.addEventListener("resize", this._checkIfPaginationInView);
      window.addEventListener("orientationchange", this._checkIfPaginationInView);
    };

    _checkIfPaginationInView = () => {

      const top =
        this.triggerElement.getBoundingClientRect().top - this.settings.offset;
      
      const bottom =
        this.triggerElement.getBoundingClientRect().bottom + this.settings.offset;

      // if the element is hidden, remove scroll listener
      if(this.triggerElement.getBoundingClientRect().width <= 0) return this._removeScrollListener();

      if ((top <= window.innerHeight && bottom >= 0)) {
        this.nextPageLinkElement = this.querySelector("a");
        this._removeScrollListener();

        if (this.nextPageLinkElement) {
          if(this.triggerElement.parentElement) {
            this.triggerElement.parentElement.insertAdjacentHTML(
            "beforeend",
            `<div class="tw-text-center m-8">${this.settings.loadingText}</div>`
          )}
          this.nextPageUrl = this.nextPageLinkElement.href;
    
          this._loadMore();
        }
      }
    };

    _removeScrollListener = () => {
      document.removeEventListener("scroll", this._checkIfPaginationInView);
      window.removeEventListener("resize", this._checkIfPaginationInView);
      window.removeEventListener("orientationchange", this._checkIfPaginationInView);
    };

    _removePaginationElement = () => {
      this.triggerElement.innerHTML = "";
      this.destroy();
    };

    //get The Html Of The Next Page With An Ajax Request
    _loadMore = () => {
      this.request = new XMLHttpRequest();

      this.request.onreadystatechange = function success() {
        if (this.request.readyState === 4 && this.request.status === 200) {
          // get the response from the request
          const res = this.request.responseText;
          // parse the response to a document object
          const htmlDoc = new DOMParser().parseFromString(res, "text/html");
          // get the next pagination element in the request
          const updatedPartial = htmlDoc.querySelector(`${this.settings.container}`);

          //add new elements to the old container
          this.containerElement.insertAdjacentHTML(
            "beforeend",
            updatedPartial.innerHTML
          );

          const newPagination = htmlDoc.querySelectorAll(`${this.settings.pagination}`)[0]?.parentElement;
          let oldPagination = document.querySelector(`${this.settings.triggerElement}`)?.parentElement;

          // update the pagination element
          oldPagination.innerHTML = newPagination.innerHTML;

          if (
            this.settings.callback &&
            typeof this.settings.callback === "function"
          ) {
            this.settings.callback(this.request.responseXML);
          }
          this.initializeInfiniteScroll();
        }
      }.bind(this);

      this.request.open("GET", this.nextPageUrl);
      this.request.send();
    };

    _destroy = () => {
      const destroyers = {
        click: this._removeClickListener,
        scroll: this._removeScrollListener,
      };
    
      destroyers[this.settings.method]();
    
      return this;
    };
}

customElements.define('infinite-scroll', InfiniteScroll);


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  
    this.infiniteScroll = new InfiniteScroll();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
    
      publish('facetsReload')
      publish('load-products-swiper');

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  // static renderProductCount(html) {
  //   const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
  //   const container = document.getElementById('ProductCount');
  //   const containerDesktop = document.getElementById('ProductCountDesktop');
  //   container.innerHTML = count;
  //   container.classList.remove('loading');
  //   if (containerDesktop) {
  //     containerDesktop.innerHTML = count;
  //     containerDesktop.classList.remove('loading');
  //   }
  //   const loadingSpinners = document.querySelectorAll(
  //     '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
  //   );
  //   loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  // }

  static renderProductCount(html) {
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    
    // Verifica se countContainer esiste prima di procedere
    if (countContainer) {
      const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML;
      if (count !== undefined) {
        countContainer.innerHTML = count;
        countContainer.classList.remove('loading');
      }
    }
  
    // Verifica se countContainerDesktop esiste prima di procedere
    if (countContainerDesktop) {
      const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCountDesktop')?.innerHTML;
      if (count !== undefined) {
        countContainerDesktop.innerHTML = count;
        countContainerDesktop.classList.remove('loading');
      }
    }
  
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }
  

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
    // this.infiniteScroll.initializeInfiniteScroll();
  }

  /**
   * Handles the form submission event.
   * @param {Event} event - The form submission event.
   */
  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
    // this.infiniteScroll.initializeInfiniteScroll();
  }

  /**
   * Handles the click event on an active filter.
   * Toggles the active facets and renders the page with the updated URL.
   * @param {Event} event - The click event.
   */
  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);

    // this.infiniteScroll.initializeInfiniteScroll();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
    this.infiniteScroll = new InfiniteScroll();
  }

  onRangeChange(event) {
    this.infiniteScroll.initializeInfiniteScroll();
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
    this.infiniteScroll = new InfiniteScroll();
  }

  closeFilter(event) {
    event.preventDefault();
    this.infiniteScroll.initializeInfiniteScroll();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);




function productGridView() {

  let switcherProduct = document.querySelectorAll('.AF_switcher-product ul li');
  let productGrid = document.querySelector('.product-grid');

  if(!productGrid) return;

  let maxCol = 4, minCol = 2;
  const switcherData = document.querySelector('.AF_switcher-product ul')?.dataset;
  if (switcherData) {
    if (switcherData.maxCol) maxCol = switcherData.maxCol;
    if (switcherData.minCol) minCol = switcherData.minCol;
  }

  // Funzione per aggiornare la vista del prodotto
  function updateProductView(view) {
    if (view === 'less-product') {
      productGrid.classList.remove('grid--'+maxCol+'-col-desktop', 'grid--2-col-tablet-down');
      productGrid.classList.add('grid--'+minCol+'-col-desktop', 'grid--1-col-tablet-down');
    } else {
      productGrid.classList.remove('grid--'+minCol+'-col-desktop', 'grid--1-col-tablet-down');
      productGrid.classList.add('grid--'+maxCol+'-col-desktop', 'grid--2-col-tablet-down');
    }
  }

  // Leggi la vista del prodotto dal localStorage e aggiorna la vista
  let savedView = localStorage.getItem('productView');
  if (savedView) {
    updateProductView(savedView);

    // Aggiorna lo stato attivo dei link nel menu
    document.querySelectorAll('.AF_switcher-product ul li a').forEach(function(link) {
      link.classList.remove("active");
      if (link.dataset.productView === savedView) {
        link.classList.add("active");
      }
    });
  }

  // Aggiungi event listener per i click
  switcherProduct.forEach(function(link) {
    link.addEventListener("click", function(event) {
      event.preventDefault(); 
      let clickedLink = this.querySelector("a");
      let view = clickedLink.dataset.productView;

      // Aggiorna la vista del prodotto
      updateProductView(view);

      // Salva la vista del prodotto nel localStorage
      localStorage.setItem('productView', view);

      // Aggiorna lo stato attivo dei link nel menu
      document.querySelectorAll('.AF_switcher-product ul li a').forEach(function(link) {
        link.classList.remove("active"); // Toglie la classe 'active' dagli altri link
      });
      clickedLink.classList.add("active"); // Aggiunge la classe 'active' sul link cliccato
    });
  });
}
subscribe('facetsReload', productGridView)
document.addEventListener("DOMContentLoaded", productGridView);




let facets = document.querySelector('.facets-wrapper');

if (facets) {
    let totalStickyHeight = 
        (document.documentElement.style.getPropertyValue("--header-height") ? 
            parseInt(document.documentElement.style.getPropertyValue("--header-height").replace("px", "")) : 0) + 
        (document.documentElement.style.getPropertyValue("--announcement-height") ? 
            parseInt(document.documentElement.style.getPropertyValue("--announcement-height").replace("px", "")) : 0);

    let partialSticky = 0;
    let stickyes = document.querySelectorAll("sticky-header");

    let countStickyAlways = 0;

    stickyes.forEach((sticky) => {
        if (sticky.dataset.stickyType == "always") {
            partialSticky += sticky.offsetHeight;
        }
    });
    window.matchMedia("(max-width: 990px)").addEventListener("change", () => {
        totalStickyHeight =
            (document.documentElement.style.getPropertyValue("--header-height") ? 
                parseInt(document.documentElement.style.getPropertyValue("--header-height").replace("px", "")) : 0) + 
            (document.documentElement.style.getPropertyValue("--announcement-height") ? 
                parseInt(document.documentElement.style.getPropertyValue("--announcement-height").replace("px", "")) : 0);

        partialSticky = 0;
        stickyes.forEach((sticky) => {
            if (sticky.dataset.stickyType == "always") {
                partialSticky += sticky.offsetHeight;
            }
        });
    });

    subscribe("sticky-header:stick", (state) => {
        if (state == "close") {
            facets.style.setProperty("top", partialSticky + "px");
        } else {
            facets.style.setProperty("top", totalStickyHeight + "px");
        }
    });
}